import { getDateFilterDefinitions } from "../definitions";
import { getAutoDateInterval } from "./formatting";
import { uniq } from "es-toolkit";
export const transformChartDataParams = (params)=>{
    const { breakdown, xAxis, dateFilter, organizationId, applicationId, variantId, experimentId, conversionTimeframe, campaignId, productDuration, countryCode, productId, placement, paywallId, revenueType, integration, subStartType, eventType, environment, productDurationInfo, userPropertyInfo, campaignIdInfo, store, appVersion, dateInterval, sdkVersion, totals, autoRenewStatus, revenueSource } = params;
    const allBreakdowns = new Set([
        ...breakdown ? [
            breakdown
        ] : [],
        xAxis
    ]);
    const dateFilterDefinitions = getDateFilterDefinitions();
    const getDatefilters = (dimension, dateFilter)=>{
        const active = dateFilterDefinitions.find((d)=>d.active) || dateFilterDefinitions[0];
        return active && dimension === dateFilter?.dimension ? {
            ...active,
            ...dateFilter
        } : undefined;
    };
    const tsDateFilter = getDatefilters("tsDate", dateFilter);
    const purchaseDateFilter = getDatefilters("purchaseDate", dateFilter);
    const installDateFilter = getDatefilters("installDate", dateFilter);
    const firstPurchaseDateFilter = getDatefilters("firstPurchaseDate", dateFilter);
    const mrrDateFilter = getDatefilters("mrrDate", dateFilter);
    let autoDateInterval = "day";
    if (dateInterval === "auto") {
        const activeFilter = purchaseDateFilter || installDateFilter || firstPurchaseDateFilter || mrrDateFilter;
        if (activeFilter && activeFilter.range) {
            autoDateInterval = getAutoDateInterval(activeFilter.range.from, activeFilter.range.to);
        }
    }
    const output = {
        breakdowns: Array.from(allBreakdowns),
        tsDate: tsDateFilter ? [
            tsDateFilter.range.from,
            tsDateFilter.range.to
        ] : [],
        purchaseDate: purchaseDateFilter ? [
            purchaseDateFilter.range.from,
            purchaseDateFilter.range.to
        ] : [],
        installDate: installDateFilter ? [
            installDateFilter.range.from,
            installDateFilter.range.to
        ] : [],
        firstPurchaseDate: firstPurchaseDateFilter ? [
            firstPurchaseDateFilter.range.from,
            firstPurchaseDateFilter.range.to
        ] : [],
        mrrDate: mrrDateFilter ? [
            mrrDateFilter.range.from,
            mrrDateFilter.range.to
        ] : [],
        productDurationInfo: productDurationInfo ? productDurationInfo.reduce((acc, { productId, duration })=>{
            acc[productId] = duration;
            return acc;
        }, {}) : {},
        campaignIdInfo: campaignIdInfo ? campaignIdInfo.reduce((acc, { campaignId, experimentId })=>{
            acc[experimentId] = campaignId;
            return acc;
        }, {}) : {},
        userPropertyInfo: userPropertyInfo ? userPropertyInfo.reduce((acc, { key, valueType })=>{
            acc[key] = valueType;
            return acc;
        }, {}) : {},
        organizationId,
        paywallId: paywallId ? paywallId : [],
        dateInterval: dateInterval === "auto" ? autoDateInterval : totals ? "totals" : dateInterval || "day",
        applicationId: applicationId ? applicationId : [],
        variantId: variantId ? variantId : [],
        experimentId: experimentId ? experimentId : [],
        conversionTimeframe: conversionTimeframe ? conversionTimeframe : "unbounded",
        campaignId: campaignId ? campaignId : [],
        productDuration: productDuration ? uniq(productDuration.flatMap((item)=>item.split("??").map((pair)=>{
                const [, duration] = pair.split(":");
                return duration;
            }))).filter(Boolean) : [],
        countryCode: countryCode ? countryCode : [],
        productId: productId ? productId : [],
        placement: placement ? placement : [],
        environment: environment ? environment : [],
        store: store ? store : [],
        appVersion: appVersion ? appVersion : [],
        sdkVersion: sdkVersion ? sdkVersion : [],
        integration: breakdown == "integration" ? [] : integration || [],
        revenueType: revenueType ? revenueType : [],
        eventType: eventType ? eventType : [],
        subStartType: subStartType ? subStartType : [],
        autoRenewStatus: autoRenewStatus ? autoRenewStatus : [],
        revenueSource: revenueSource ? revenueSource : []
    };
    console.log("[!] transformChartDataParams", output);
    return output;
};
